/* globals Hammer */
import {AriaModal, AriaTab} from '../library/_aria';
import {convertKeycodeToKeygroup} from '../library/_keyboard';

export default {
  init() {
    // タブ切り替えの実装(ステート）
    const albumTablist = document.querySelector('#albumTablist');
    const tabAria = new AriaTab(albumTablist);
    tabAria.setRadio('click', slideNear);

    const albumModal = document.querySelector('#albumModal');
    const albumModalImg = document.querySelector('#albumModalImg');

    // スワイプ検出
    const modalHammer = new Hammer(albumModal);
    modalHammer.on('swipeleft', slideNext);
    modalHammer.on('swiperight', slidePrev);

    // スクロールロックの準備
    const showModal = (aria) => {
      // Object.assign(albumTablist.style, {
      //   position: 'fixed',
      //   right: '8px',
      //   top: (window.innerWidth > 600)? '160px': '80px',
      // });
      albumModalImg.style.backgroundImage = `url('${aria.initiator.dataset.asset}')`;
      document.body.classList.add('is-modal');
      no_scroll()
    };
    const hideModal = () => {
      // Object.assign(albumTablist.style, {
      //   position: '',
      //   right: '',
      //   top: '',
      // });
      document.body.classList.remove('is-modal');
      return_scroll();
    };

    // モーダルの実装
    const modalAria = new AriaModal(albumModal);
    modalAria.setToggle('click', showModal, hideModal);

    // 前のスライドへ
    const btnAlbumPrev = document.querySelector('#albumPrev');
    btnAlbumPrev.addEventListener('click', slidePrev);

    // 次のスライドへ
    const btnAlbumNext = document.querySelector('#albumNext');
    btnAlbumNext.addEventListener('click', slideNext);

    // キーボード入力受付
    window.addEventListener('keydown', (event) => {
      const keygroups = convertKeycodeToKeygroup(event.keyCode);

      // タブを移動する準備
      const tabItems = document.querySelectorAll('.album__tabitem');
      const currentIndex = Array.from(tabItems).reduce((acc, cur, idx) => {
        if(cur.getAttribute('aria-selected') === 'true') {
          return idx;
        } else {
          return acc;
        }
      }, 0);
      const statemap = Array.from(tabItems).map(elem => elem.dataset.state);

      // タブの移動先計算
      const prevTabIndex = Math.max((currentIndex - 1), 0);
      const nextTabIndex = Math.min((currentIndex + 1), (statemap.length - 1));

      // モーダル展開時
      if(albumModal.classList.contains('is-active')) {
        console.log(keygroups);
        // 右を押下時
        if(keygroups.includes('right')) {
          slideNext();
        }
        // 左を押下時
        if(keygroups.includes('left')) {
          slidePrev();
        }
        // バックスペースなどを押下時
        if(keygroups.includes('negative')) {
          modalAria.shrink(hideModal);
        }
        // 上を押下時
        if(keygroups.includes('up')) {
          tabAria.select('albumList', statemap[prevTabIndex], slideNear);
          event.preventDefault(); //スクロールを抑制
        }
        // 下を押下時
        if(keygroups.includes('down')) {
          tabAria.select('albumList', statemap[nextTabIndex], slideNear);
          event.preventDefault(); //スクロールを抑制
        }
      }
    })
  },
};

function slideNear() {
  const albumModalImg = document.querySelector('#albumModalImg');
  const albumList = document.querySelector('#albumList');
  const albumItems = document.querySelectorAll('.album__item');
  const length = albumItems.length;

  const current = parseInt(albumModalImg.style.backgroundImage.match(/al(\d+)@/)[1]) - 1;

  // カテゴリ内で直近のスライドを検索する
  let near = current;
  if(albumList.dataset.state) {
    let stopper = length;
    console.log('state:', albumList.dataset.state, 'classList', albumItems[near].classList);
    while (!albumItems[near].classList.contains(albumList.dataset.state) && stopper > 0) {
      near = (near + 1) % length;
      stopper--;
    }
  }
  albumModalImg.style.backgroundImage = `url('${albumItems[near].dataset.asset}')`;
}


function slidePrev() {
  const albumModalImg = document.querySelector('#albumModalImg');
  const albumList = document.querySelector('#albumList');
  const albumItems = document.querySelectorAll('.album__item');
  const length = albumItems.length;

  const current = parseInt(albumModalImg.style.backgroundImage.match(/al(\d+)@/)[1]) - 1;

  // カテゴリ内で前のスライドを検索する
  let prev = (current + length - 1) % length;
  if(albumList.dataset.state) {
    let stopper = length;
    while (!albumItems[prev].classList.contains(albumList.dataset.state) && stopper > 0) {
      prev = (prev + length - 1) % length;
      stopper--;
    }
  }
  albumModalImg.style.backgroundImage = `url('${albumItems[prev].dataset.asset}')`;
}

function slideNext() {
  const albumModalImg = document.querySelector('#albumModalImg');
  const albumList = document.querySelector('#albumList');
  const albumItems = document.querySelectorAll('.album__item');
  const length = albumItems.length;

  const current = parseInt(albumModalImg.style.backgroundImage.match(/al(\d+)@/)[1]) - 1;
  // カテゴリ内で次のスライドを検索する
  let next = (current + 1) % length;
  if(albumList.dataset.state) {
    let stopper = length;
    while(!albumItems[next].classList.contains(albumList.dataset.state) && stopper > 0) {
      next = (next+length+1)%length;
      stopper--;
    }
  }
  albumModalImg.style.backgroundImage = `url('${albumItems[next].dataset.asset}')`;
}

// スクロール禁止
function no_scroll() {
  // PCでのスクロール禁止
  document.addEventListener('mousewheel', scroll_control, { passive: false });
  // スマホでのタッチ操作でのスクロール禁止
  document.addEventListener('touchmove', scroll_control, { passive: false });
}
// スクロール禁止解除
function return_scroll() {
  // PCでのスクロール禁止解除
  document.removeEventListener('mousewheel', scroll_control, { passive: false });
  // スマホでのタッチ操作でのスクロール禁止解除
  document.removeEventListener('touchmove', scroll_control, { passive: false });
}

// スクロール関連メソッド
function scroll_control(event) {
  event.preventDefault();
}



// WEBPACK FOOTER //
// ./scripts/routes/album.js